import React, { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTER_LINKS } from '../../consts/app-keys.const';
import { useOutsideAlerter } from '../../../hooks/click-outside';
import ProductsDropdown from './products-dropdown.component';
import ResourcesDropdown from './resources-dropdown.component';

interface HeaderNavProps {
  isMobile?: boolean;
}

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `relative font-body text-medium transition-colors hover:bg-surface-hover hover:text-blue px-[16px] py-[7px] rounded-[999px]
  after:content-[''] after:absolute after:bottom-[0px] after:left-[7px] after:right-[7px] after:h-[2px] after:rounded-full after:transition-transform after:duration-300 after:origin-center
  ${isActive
    ? 'text-base-black after:bg-base-black after:scale-x-100'
    : 'text-content-primary after:bg-blue after:scale-x-0 hover:after:scale-x-100'}`;

const HeaderNav: React.FC<HeaderNavProps> = ({ isMobile = false }) => {
  const { t } = useTranslation();
  const [openDropdown, setOpenDropdown] = useState<'products' | 'resources' | null>(
    null
  );
  const navRef = useRef<HTMLElement>(null);

  useOutsideAlerter(navRef, () => setOpenDropdown(null));

  return (
    <nav ref={navRef}>
      <ul
        className={`flex items-center ${isMobile ? 'flex-col gap-[18px] text-[18px]' : 'gap-[28px]'}`}
      >
        {/* Services leads. It is a destination people arrive looking for
            rather than browse into, so it gets a direct link instead of a
            row inside the Products menu. */}
        <li>
          <NavLink to={ROUTER_LINKS.RIGGING_SERVICES} className={navLinkClass}>
            {t('header.services')}
          </NavLink>
        </li>
        {!isMobile && (
          <li>
            <ProductsDropdown
              isOpen={openDropdown === 'products'}
              onOpen={() => setOpenDropdown('products')}
              onClose={() => setOpenDropdown(null)}
            />
          </li>
        )}
        {!isMobile && (
          <li>
            <ResourcesDropdown
              isOpen={openDropdown === 'resources'}
              onOpen={() => setOpenDropdown('resources')}
              onClose={() => setOpenDropdown(null)}
            />
          </li>
        )}
        {/* The rig library is TouchPose's, not the site's, so it now sits
            beside the TouchPose trial button and in the Products panel rather
            than competing at nav level. */}
        <li>
          <NavLink to={ROUTER_LINKS.CONTACT} className={navLinkClass}>
            {t('header.contact')}
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default HeaderNav;
